import SLOTS_MAP from '../../../maps/slots.map';
import { CTATag } from '../../atoms/CTA/CTA.constants';

/**
 * @param {Object} param
 * @param {boolean} param.hasDataPrivacyCheck
 * @param {boolean} param.hasWorkPermitCheck
 * @param {boolean} param.isDataPrivacyAccepted
 * @param {boolean} param.isWorkPermitAccepted
 * @returns {GetJobDetailContactCTAtype}
 */
export const getJobDetailContactCTAtype = ({
  hasDataPrivacyCheck,
  hasWorkPermitCheck,
  isDataPrivacyAccepted,
  isWorkPermitAccepted,
}) => {
  // If neither check is required, use Link
  if (!hasDataPrivacyCheck && !hasWorkPermitCheck) {
    return CTATag.Link;
  }
  // If data privacy is required and not accepted, use Button
  if (hasDataPrivacyCheck && !isDataPrivacyAccepted) {
    return CTATag.Button;
  }
  // If work permit is required and not accepted, use Button
  if (hasWorkPermitCheck && !isWorkPermitAccepted) {
    return CTATag.Button;
  }
  // Otherwise, use Link
  return CTATag.Link;
};

/**
 * @param {*} content
 * @param {string} slotName
 * @returns {ApiElements}
 */
export const updateSharedContentProps = (content, slotName) => {
  let modifiedContent = content;
  const isContainer = content.some(
    (t) =>
      t.type === 'CONTAINER_LARGE_A' ||
      t.type === 'CONTAINER_LARGE_B' ||
      t.type === 'CONTAINER_LARGE_C',
  );
  const containerIndex = content.findIndex(
    (k) =>
      k.type === 'CONTAINER_LARGE_A' ||
      k.type === 'CONTAINER_LARGE_B' ||
      k.type === 'CONTAINER_LARGE_C',
  );
  switch (slotName) {
    case SLOTS_MAP.currentInformation:
      if (isContainer) {
        modifiedContent[containerIndex] = {
          ...modifiedContent[containerIndex],
          style: 'GRAY',
          hasLasche: true,
        };
      }
      break;
    case SLOTS_MAP.slot2:
      if (isContainer) {
        modifiedContent[containerIndex] = {
          ...modifiedContent[containerIndex],
          style: 'NONE',
          hasLasche: true,
        };
      }
      break;
    case SLOTS_MAP.slot3:
      if (isContainer) {
        modifiedContent[containerIndex] = {
          ...modifiedContent[containerIndex],
          style: 'BRAND',
          hasLasche: true,
        };
      }
      break;
    case SLOTS_MAP.slot5:
      if (isContainer) {
        modifiedContent[containerIndex] = {
          ...modifiedContent[containerIndex],
          style: 'GRAY',
          hasLasche: true,
        };
      }
      break;
    default:
      modifiedContent = content;
      break;
  }

  return modifiedContent;
};

/**
 * @param {string} slotName
 * @returns {SpacingType}
 */
export const createJobDetailSlotsSpacing = (slotName) => {
  /**
   * @type {SpacingType}
   */
  let spacing;
  switch (slotName) {
    case SLOTS_MAP.currentInformation:
      spacing = 'spacing300';
      break;
    case SLOTS_MAP.slot2:
      spacing = 'spacing300';
      break;
    case SLOTS_MAP.slot5:
      spacing = 'spacing300';
      break;
    case SLOTS_MAP.information:
      spacing = 'spacing900';
      break;
    default:
      spacing = 'spacing0';
      break;
  }
  return spacing;
};
